<!--
Vyhladavanie sa spusti 500ms po tom ako pouzivatel skonci pisanie. Je to koli tomu aby sa neserver neposielalo zbytocne vela requestov.
Je to mozne zmenit parametrom VYHLADAVANIE_DELAY

!!! POZOR kontrolka vracia cely objekt, nie len hodnotu !!!

objekt ma strukturu podla selectu:
{ 
    ico: "31142940"
    id_zakaznika: 121267
    je_pobocka: null
    retencia_info: ""
    retencna_perioda_do: "2035-03-06T00:00:00"
    retencna_perioda_od: "2023-03-06T00:00:00"
    snazov: "JUDr. Ing. Anna Martišíková"
    tooltip: "IČO/RČ:31142940\rSamoty 1061,02001 Púchov.\r"
  }
-->

<template>
  <v-form ref="form">
    <div v-if="!isKlient">
      <v-autocomplete
        ref="ico"
        :errorMessages="errorMessages"
        @input="
          newVal => {
            setDirty(true);
            updateIco(newVal);
          }
        "
        :value="ico"
        outlined
        :items="items"
        :loading="isLoading"
        hide-no-data
        label="IČO"
        class="dynamic-input-control"
        :append-icon="isDisabled ? '' : 'mdi-chevron-down'"
        :search-input.sync="icoSearch"
        :disabled="isDisabled"
        :rules="getRules"
        :class="{
          validated: displayValidated && !hasError && !errorMessages,
          required: true,
          readonly,
        }"
        :readonly="isLoading || isDisabled"
        return-object
        item-text="ico"
        item-value="ico"
      >
        <template v-slot:item="{ item }">
          <div class="d-flex w100">
            <div class="d-flex mr-25px">
            <div>
              <span
                v-for="(i, index) in generateMaskTextArray(icoSearch, item.ico)"
                :key="index"
                :class="{ 'v-list-item__mask': i.mask }"
                class="v-center-text"
              >
                {{ i.text }}
              </span>
            </div>
            </div>
            <span class="f14 pl-2px ico-item-cor v-center-text">{{ item.snazov }}</span>
          </div>
        </template>
      </v-autocomplete>

      <v-autocomplete
        ref="obch_meno"
        :errorMessages="errorMessages"
        @input="
          newVal => {
            setDirty(true);
            updateObchM(newVal);
          }
        "
        :value="obchodneMeno"
        outlined
        :items="items"
        :loading="isLoading"
        hide-no-data
        label="Obchodné meno/Meno a priezvisko"
        class="dynamic-input-control"
        :append-icon="isDisabled ? '' : 'mdi-chevron-down'"
        :search-input.sync="obchodneMenoSearch"
        :disabled="isDisabled"
        :rules="getRules"
        :class="{
          validated: displayValidated && !hasError && !errorMessages,
          required: true,
          readonly,
        }"
        :readonly="isLoading || isDisabled"
        return-object
        item-text="snazov"
        item-value="snazov"
      >
        <template v-slot:item="{ item }">
          <div class="d-flex w100">
            <div class="d-flex mr-25px w250px" style="overflow: hidden">
              <div>
              <span
                v-for="(i, index) in generateMaskTextArray(obchodneMenoSearch, item.snazov)"
                :key="index"
                :class="{ 'v-list-item__mask': i.mask }"
                class="v-center-text"
              >
                {{ i.text }}
              </span>
            </div>
            </div>
            <div class="v-center-text w70px ml-auto">{{ item.ico }}</div>
          </div>
        </template>
      </v-autocomplete>
    </div>
    <div v-else>
      <v-combobox
        ref="ico"
        :errorMessages="errorMessages"
        @input="
          newVal => {
            setDirty(true);
            updateIco(newVal);
          }
        "
        :value="ico"
        outlined
        :items="items"
        :loading="isLoading"
        hide-no-data
        label="IČO"
        class="dynamic-input-control"
        :append-icon="isDisabled ? '' : 'mdi-chevron-down'"
        :search-input.sync="icoSearch"
        :disabled="isDisabled"
        :class="{
          validated: displayValidated && !hasError && !errorMessages,
          readonly,
        }"
        :readonly="isLoading || isDisabled"
        return-object
        item-text="ico"
        item-value="ico"
      >
        <template v-slot:item="{ item }">
          <div class="d-flex w100">
            <div class="d-flex mr-25px">
            <div>
              <span
                v-for="(i, index) in generateMaskTextArray(icoSearch, item.ico)"
                :key="index"
                :class="{ 'v-list-item__mask': i.mask }"
                class="v-center-text"
              >
                {{ i.text }}
              </span>
            </div>
            </div>
            <span class="f14 pl-2px ico-item-cor v-center-text">{{ item.snazov }}</span>
          </div>
        </template>
      </v-combobox>

      <v-combobox
        ref="obch_meno"
        :errorMessages="errorMessages"
        @input="
          newVal => {
            setDirty(true);
            updateObchM(newVal);
          }
        "
        :value="obchodneMeno"
        outlined
        :items="items"
        :loading="isLoading"
        hide-no-data
        label="Obchodné meno/Meno a priezvisko"
        class="dynamic-input-control"
        :append-icon="isDisabled ? '' : 'mdi-chevron-down'"
        :search-input.sync="obchodneMenoSearch"
        :disabled="isDisabled"
        :rules="getRules"
        :class="{
          validated: displayValidated && !hasError && !errorMessages,
          required: true,
          readonly,
        }"
        :readonly="isLoading || isDisabled"
        return-object
        item-text="snazov"
        item-value="snazov"
      >
        <template v-slot:item="{ item }">
          <div class="d-flex w100">
            <div class="d-flex mr-25px w250px" style="overflow: hidden">
              <div>
              <span
                v-for="(i, index) in generateMaskTextArray(obchodneMenoSearch, item.snazov)"
                :key="index"
                :class="{ 'v-list-item__mask': i.mask }"
                class="v-center-text"
              >
                {{ i.text }}
              </span>
            </div>
            </div>
            <div class="v-center-text w70px ml-auto">{{ item.ico }}</div>
          </div>
        </template>
      </v-combobox>
    </div>
  </v-form>
</template>
<script>
import { dynamicControlMixin } from '../../mixins/dynamicControlMixin';
import protectedAxios from '../../auth/axios.js';

import axios from 'axios';

export default {
  mixins: [dynamicControlMixin],
  props: {
    isKlient: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
  },
  watch: {
    currentItem(val) {
        console.log(this.currentItem)        
        this.$emit('updateValue', val);
    },
    icoSearch(val) {
      if (this.isIcoUpdating) {
        this.isIcoUpdating = false;
        return;
      }
      if (val != null && val != '') {
        val = val?.replace(/[^\d]/g, '');
        this.icoSearch = val;
        this.$refs.ico.lazySearch = val;
      }

      clearTimeout(this.loadingTimeout);

      this.loadingTimeout = setTimeout(() => this.obnovAutoComplete('#'+val), this.VYHLADAVANIE_DELAY);
    },
    obchodneMenoSearch(val) {
      if (this.isObchodMenoUpdating) {
        this.isObchodMenoUpdating = false;
        return;
      }
      if (val != null && val != '') {
        this.obchodneMenoSearch = val;
        this.$refs.obch_meno.lazySearch = val;
      }

      clearTimeout(this.loadingTimeout);

      this.loadingTimeout = setTimeout(() => this.obnovAutoComplete(val), this.VYHLADAVANIE_DELAY);
    },
  },
  data() {
    return {
      data: null,
      isLoading: false,
      obchodneMenoSearch: null,
      icoSearch: null,
      loadingTimeout: null,
      items: [],
      ico: null,
      currentItem: null,
      VYHLADAVANIE_DELAY: 500,
      obchodneMeno: null,
      isIcoUpdating: false,
      isObchodMenoUpdating: false,
    };
  },
  methods: {
    generateMaskTextArray(search, nazov) {
      if (!search) {
        return [
          {
            text: nazov,
            mask: false,
          },
        ];
      }

      const index = nazov.toLowerCase().indexOf(search.toLowerCase());
      const sLength = search.length;
      const nLength = nazov.length;

      //search na zaciatku
      if (index === 0) {
        return [
          {
            text: nazov.substring(0, sLength),
            mask: true,
          },
          {
            text: nazov.substring(sLength, nLength),
            mask: false,
          },
        ];
      }

      if (index + sLength === nLength) {
        //search na konci
        return [
          {
            text: nazov.substring(0, index),
            mask: false,
          },
          {
            text: nazov.substring(index, sLength),
            mask: true,
          },
        ];
      } else {
        //search medzi
        return [
          {
            text: nazov.substring(0, index),
            mask: false,
          },
          {
            text: nazov.substring(index, index + sLength),
            mask: true,
          },
          {
            text: nazov.substring(index + sLength, nLength),
            mask: false,
          },
        ];
      }
    },
    obnovAutoComplete(query) {
      if (query == '' || query == null || query.length < 3) return
      this.isLoading = false;

      let url = `controls/zakaznik?query=${encodeURIComponent(query)}&newId=${this.pripad?.newId ?? ''}`;

      return protectedAxios
        .get(url)
        .then(res => {
          this.isLoading = false;
          if (Array.isArray(res.data)) {
            this.items = res.data
          }
        })
        .catch(e => {
          if (!axios.isCancel(e)) {
            console.error(e);
            this.errorMessages = 'Chyba pri načítaní dát.';
            this.isLoading = false;
          }
        });
    },
    updateIco(newVal) {
      if(this.isKlient){
        if(typeof newVal === 'object' ){
          if (this.currentItem?.ico === newVal?.ico) return;
          this.currentItem = newVal;
        }else{
          if (this.currentItem?.ico === newVal) return;
          if(this.currentItem == null){
            this.currentItem = {snazov: null, ico: null};
          }else{
            if(this.currentItem?.id_zakaznika){
              this.currentItem = {snazov: null, ico: null};
              this.obchodneMeno = null;
            }
          }
          this.currentItem.ico = newVal;
        }
      }else{
        if (this.currentItem?.ico === newVal?.ico) return;
        this.currentItem = newVal;
      }

      this.isObchodMenoUpdating = true;
      if (
        (this.ico != this.currentItem?.ico) ||
        (this.obchodneMeno != newVal?.snazov)
      ) {
        if(typeof newVal === 'object' ){
          this.obchodneMeno = newVal ? newVal.snazov : null;
        }
        this.ico = this.currentItem ? this.currentItem.ico : null;
      }
    },
    updateObchM(newVal) {
      if(this.isKlient){
        if(typeof newVal === 'object' ){
          if (this.currentItem?.snazov === newVal?.snazov) return;
          this.currentItem = newVal;
        }else{
          if (this.currentItem?.snazov === newVal) return;
          if(this.currentItem == null){
            this.currentItem = {snazov: null, ico: null};
          }else{
            if(this.currentItem?.id_zakaznika){
              this.currentItem = {snazov: null, ico: null};
              this.ico = null;
            }
          }
          this.currentItem.snazov = newVal;
        }
      }else{
        if (this.currentItem?.snazov === newVal?.snazov) return;
        this.currentItem = newVal;
      }

      this.isIcoUpdating = true;
      if (
        (this.ico != newVal?.ico) ||
        (this.obchodneMeno != this.currentItem?.snazov)
      ) {
        if(typeof newVal === 'object' ){
          this.ico = newVal ? newVal.ico : null;
        }
        this.obchodneMeno = this.currentItem ? this.currentItem.snazov : null;
      }
    }
  },
  mounted() {
  },
};
</script>
